import { correctColor } from "../../constants/Constants";
import { Tex } from "react-tex";

export default function M_Type(props) {
  const question = props.question;

  const color = correctColor();

  const getNumText = () => {
    var text;

    if (question.type === "text") {
      text = question.number;
    } else {
      text = question.number + " " + question.options[0].text;
    }
    return text;
  };

  return (
    <div
      style={{
        width: "45%",
        backgroundColor: color,
        textAlign: "center",
        borderRadius: "5px",
      }}
    >
      <text>{getNumText()}</text>
    </div>
  );
}
